var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSearchGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2116_283)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.7212 46.1871L40.3062 33.7712C42.4893 30.3011 43.6451 26.2838 43.6399 22.1841C43.6399 10.1328 33.8703 0.364594 21.8195 0.364594C9.76867 0.364594 0 10.1328 0 22.1841C0 34.2358 9.76821 44.0031 21.8195 44.0031C26.2767 44.0088 30.6278 42.6431 34.2822 40.0912L46.5494 52.3593C46.9545 52.7646 47.4356 53.0859 47.9651 53.3048C48.4947 53.5237 49.0623 53.6359 49.6353 53.6349C50.2085 53.6359 50.7763 53.5238 51.3061 53.3049C51.8359 53.086 52.3172 52.7646 52.7225 52.3593C53.5407 51.5405 54.0001 50.4304 53.9999 49.2729C53.9996 48.1154 53.5397 47.0055 52.7212 46.1871ZM21.8195 36.9339C13.6742 36.9339 7.07056 30.3307 7.07056 22.185C7.07056 14.0393 13.6742 7.43561 21.8195 7.43561C29.9652 7.43561 36.5684 14.0393 36.5684 22.185C36.5684 30.3307 29.9652 36.9339 21.8195 36.9339Z",
    fill: "#ABE832"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2116_283"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 54,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearchGreen);
export default __webpack_public_path__ + "static/media/icon-search--green.4292d6fcffd5863a7abc8a5746da7a73.svg";
export { ForwardRef as ReactComponent };